import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangePurchaseNetPriceInCurrencyCommand extends BaseCommand {
  CommandName = "ChangePurchaseNetPriceInCurrency";
  Command: {
    Amount: number;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, amount: number) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Amount: amount };
  }
}
